import styled from 'styled-components'

export const TopNavbarContainer = styled.div`
    position: fixed;
    width: 100%;
    z-index: 1;
    
    .topnavbar-row{
        width: 100%;
        background-color: white;
        position: absolute;
        height: 88px;
        padding-top: 28px;
        padding-right: 18px;
        padding-left: 18px;
        border-bottom: 1px solid rgba(51,102,255, .10);
        
    }

    .topnavbar-hamburger{
        font-size: 18px;
    }

    @media (min-width: 768px){
        .topnavbar-hamburger{
            display: none;
        }
    }

`

